import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {Button, CoreDI, DeviceType, inject, ObjectBuilder, Text} from '@gongxigames/framework/core';
import {MenuBarView} from '@gongxigames/framework/slot/modules/menubar/MenuBarView';
import {KeypadView, KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad';
import {GameConfig} from '@gongxigames/framework/slot';

export class MenuBarViewMobileLandscape extends MenuBarView {
    public static readonly NAME: symbol = Symbol('MenuBarViewMobileLandscape');
    public static layer = LAYERS.SYSTEM_POPUPS;
    public static platform: DeviceType = DeviceType.MOBILE;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    protected _buttonPanelPosition = {
        width: 2150,
        x: 1680,
        y: 140
    };

    protected initMainSprite(): void {
        this._menuBar = this._objectBuilder.buildSprite(ObjectBuilder.resources.shared_sprite.menuBar);
    }

    protected initGraphicElements(): void {
        this._menuButton = this.mainSprite.getChildByName<Button>('menuButton');
        this._label = this._menuBar.getChildByName<Text>('label');
    }

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }

    protected updateButtonPanelPosition(): void {
        const k4Width = this._gameConfig.viewport.mobile.width;
        const offset = 1680;

        this._buttonPanelPosition = {
            width: k4Width - offset,
            x: offset,
            y: 140
        };
    }

    public getViewDependencies(): (symbol|string)[] {
        return [KeypadViewMobileLandscape.NAME];
    }
}
